export enum ESliceKeys {
  BrowserPage = 'browserPage',
  Chat = 'chat',
  JsonQuery = 'jsonQuery',
  ListingLayout = 'listingLayout',
  MapConfiguration = 'mapConfiguration',
  MapControls = 'mapControls',
}
